export default "__VITE_ASSET__$vp8yIXY__"